var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtcMarkerImageSrcUnselect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0365 33.6068C16.6107 34.1448 16.2544 34.6615 16 35.0516C15.7456 34.6615 15.3893 34.1448 14.9635 33.6068C14.5237 33.0513 14.0026 32.464 13.4362 31.969C12.8751 31.4786 12.2399 31.0525 11.5696 30.8577C5.16748 28.9516 0.5 23.0202 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 23.0202 26.8325 28.9516 20.4303 30.8577C19.7601 31.0525 19.1249 31.4786 18.5638 31.969C17.9974 32.464 17.4763 33.0513 17.0365 33.6068Z",
    fill: "white",
    stroke: "#4A7FF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3499 15.3258C17.3499 16.0714 16.7454 16.6758 15.9999 16.6758C15.2543 16.6758 14.6499 16.0714 14.6499 15.3258C14.6499 14.5802 15.2543 13.9758 15.9999 13.9758C16.7454 13.9758 17.3499 14.5802 17.3499 15.3258Z",
    fill: "#4A7FF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3999 15.3258C21.3999 16.0714 20.7954 16.6758 20.0499 16.6758C19.3043 16.6758 18.6999 16.0714 18.6999 15.3258C18.6999 14.5802 19.3043 13.9758 20.0499 13.9758C20.7954 13.9758 21.3999 14.5802 21.3999 15.3258Z",
    fill: "#4A7FF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2999 15.3258C13.2999 16.0714 12.6954 16.6758 11.9499 16.6758C11.2043 16.6758 10.5999 16.0714 10.5999 15.3258C10.5999 14.5802 11.2043 13.9758 11.9499 13.9758C12.6954 13.9758 13.2999 14.5802 13.2999 15.3258Z",
    fill: "#4A7FF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcMarkerImageSrcUnselect);
export default __webpack_public_path__ + "static/media/etcMarkerImageSrc_unselect.d85dfacf719d68b560a169894f4d9392.svg";
export { ForwardRef as ReactComponent };